<template>
  <div>
    <v-range-slider class="mt-0" :value="value" :min="min" :max="max" @input="$emit('input', $event)" hide-details />
    <div class="hvh-flex space-between">
      <input class="input" :value="value[0]" type="number" @input="$emit('input', [$event.target.value, value[1]])" />
      <input class="input" :value="value[1]" type="number" @input="$emit('input', [value[0], $event.target.value])" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'min', 'max'],
}
</script>


<style lang="scss" scoped>
.input {
  box-sizing: border-box;
  width: 88px;
  padding: 5px;
  border: 1px solid #b0b3b6;
  background-color: #ffffff;
  min-width: 60px;
}
</style>